import { render, staticRenderFns } from "./EmailHtmlFrame.vue?vue&type=template&id=844f2d82&scoped=true&"
import script from "./EmailHtmlFrame.vue?vue&type=script&lang=ts&"
export * from "./EmailHtmlFrame.vue?vue&type=script&lang=ts&"
import style0 from "./EmailHtmlFrame.vue?vue&type=style&index=0&id=844f2d82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844f2d82",
  null
  
)

export default component.exports